import { render, staticRenderFns } from "./AddStandardList.vue?vue&type=template&id=79e85a6d"
import script from "./AddStandardList.vue?vue&type=script&lang=js"
export * from "./AddStandardList.vue?vue&type=script&lang=js"
import style0 from "./AddStandardList.vue?vue&type=style&index=0&id=79e85a6d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports